module.exports = __webpack_public_path__ + "static/media/Apple Watch 40mm Silver Aluminum + Clementine Closed.44e77dc8.png";